/** @jsx jsx */
import { jsx, Styled } from "theme-ui";
import { Layout } from "components/common";
import Article from "components/article";
import { Helmet } from "react-helmet";
const Archive = ({ archive }) => {
  return (
    <Layout sx={{ py: "4" }}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>the5ive: the list of archive articles</title>
        <link rel="canonical" href="https://the5ive.now.sh/archive" />
      </Helmet>
      <Styled.h2 sx={{ px: "3" }}>Archive Lists: </Styled.h2>
      <div
        sx={{
          display: "grid",
          gridGap: 4,
          gridTemplateColumns: ["auto", "1fr 1fr 1fr"]
        }}
      >
        {archive.map(article => {
          return <Article key={article.id} article={article} />;
        })}
      </div>
    </Layout>
  );
};

export default Archive;
